import { useEffect, useState, useRef } from 'react';
import CloseButton from "./CloseButton";
import Category from "./Category";
import { useCategoryDataContext } from "./context/CategoryDataContext";
import { useScore } from './context/ScoreContext';

const Hint = ({ opId, allIds, validIds, onClose, selectedHintIds, onUseHint }) => {

    const categoryData = useCategoryDataContext();
    const { day, updateHintState, gameEnded, cs } = useScore();

    const [usedHint, setUsedHint] = useState(false);
    const [hintServantIds, setHintServantIds] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const hintRef = useRef(null);

    const category1 = 3 + Math.ceil(opId / 3);
    const category2 = (opId % 3) + (opId % 3 === 0 ? 3 : 0);

    useEffect(() => {
        hintRef.current.setAttribute('tabIndex', '0');
        hintRef.current.focus();
        if (selectedHintIds.length > 0) {
            setHintServantIds(selectedHintIds);
            setUsedHint(true);
        } else {
            // let localDayData = localStorage.getItem(`day${day}`);
            // if (!localDayData) return;
            // localDayData = JSON.parse(localDayData);
            // if (!localDayData[opId]) return;
            // const savedHintIds = localDayData[opId]['hint'];
            // // console.log(localDayData);
            // if (savedHintIds && savedHintIds.length > 0) {
            //     setHintServantIds(savedHintIds);
            //     onUseHint(savedHintIds)
            //     setUsedHint(true);
            // }
        }
    }, [])

    const handleNext = () => {
        setCurrentIndex((currentIndex + 1) % hintServantIds.length);
    };

    const handlePrevious = () => {
        setCurrentIndex((currentIndex - 1 + hintServantIds.length) % hintServantIds.length);
    };


    // console.log(hintServantId);
    /** 
     * 
     * @param {number} max Maximum range 
     * @returns random int in range [0, max)
     */
    function getRandomInt(max) {
        return Math.floor(Math.random() * max);
    }

    const imgUrl = (id) => {
        return `https://static.atlasacademy.io/JP/Servants/Status/${id}/status_servant_1.png`;
    }


    const generateRandomUnvalidIds = (randomValidId) => {
        let ids = [];
        for (let i = 0; i < 4; i++) {
            const rId = allIds[getRandomInt(allIds.length)]['id'];
            if (!ids.includes(rId) && rId !== randomValidId) {
                ids.push(rId);
            }
        }
        ids.push(randomValidId);
        return ids.map(value => ({ value, sort: Math.random() }))
            .sort((a, b) => a.sort - b.sort)
            .map(({ value }) => value);
    }
    const decCSinLocalStorage = () => {
        let localDayData = localStorage.getItem(`day${day}`);
        if (!localDayData) return;
        localDayData = JSON.parse(localDayData);
        localDayData['cs'] -= 1;
        localStorage.setItem(`day${day}`, JSON.stringify(localDayData));
    }

    const useHint = () => {
        // let cs = getCScount();
        if (cs > 0 && !gameEnded) {
            const randomValidId = validIds[getRandomInt(validIds.length)];
            const randomUnvalidIds = generateRandomUnvalidIds(randomValidId);
            // console.log(randomUnvalidIds);
            setHintServantIds(randomUnvalidIds);
            onUseHint(randomUnvalidIds);
            setUsedHint(true);
            updateHintState(opId, randomUnvalidIds);
            // updateCommandSpell(getCScount() - 1);
            // decCSinLocalStorage();
        }
    }

    const handleKeyPress = (event) => {
        if (event.key === 'Escape') {
            onClose();
        }
        if (event.key === 'ArrowRight') {
            handleNext();
        }
        if (event.key === 'ArrowLeft') {
            handlePrevious();
        }
    };
    //<img src={imgUrl(hintServantId)} style={{width:"100%",filter:"brightness(0)"}}/>

    return (
        <div className="panel" ref={hintRef} onKeyDown={handleKeyPress} style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <CloseButton onClose={onClose} />
            <h1 style={{ padding: "10px" }}>Hint</h1>
            <div className='hint-selection-area' style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "10px", width: "100%" }}>
                <div onClick={handlePrevious} ><img src="navArrow.png" className="hint-arrow-left" /></div>
                <div style={{ padding: "10px", border: "1px solid #ceaa57", background: "rgba(20, 31, 46, 0.8)", boxShadow: "inset 0 0 10px rgba(0,0,0,0.8)", minWidth: "64px", minHeight: "64px", width: "80%", aspectRatio: "1/1" }}>
                    {usedHint && <div className="slider">
                        {hintServantIds.map((imageId, index) => (
                            <img
                                key={index}
                                src={imgUrl(imageId)}
                                alt=""
                                className={`slide ${index === currentIndex ? 'active' : ''}`}
                            />
                        ))} </div>}
                </div>
                <div onClick={handleNext} ><img src="navArrow.png" className="hint-arrow" /></div>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(2,  1fr)", gap: "20px", maxWidth: "75%", padding: "10px", alignItems: "center", border: "1px solid #ceaa57", background: "rgba(20, 31, 46, 0.8)", boxShadow: "inset 0 0 10px rgba(0,0,0,0.8)" }}>
                <Category data={categoryData[category1]} />
                <Category data={categoryData[category2]} />

            </div>
            {!usedHint ? <button className="score-button" onClick={useHint}>{cs > 0 ? "Use Command Spell" : "No Command Spell left"}</button> :
                <div style={{ margin: "10px", padding: "5px", border: "1px solid #ceaa57", background: "rgba(20, 31, 46, 0.8)", boxShadow: "inset 0 0 10px rgba(0,0,0,0.8)", fontSize: "small", color: "#e0e0e0" }}>
                    At least one of the servants above fits the category criteria.
                    Use left/right arrows to cycle between the possible servants.</div>}
        </div>);
}

export default Hint;